import React, {useEffect, useMemo, useState} from 'react';
import {InputAdornment, Stack, TextField} from "@mui/material";
import {connect} from "react-redux";
import Loader from "./layout/loading/loader";
import ButtonCreate from "./layout/ButtonCreate";
import Constants from "../../utils/constants";
import {formsActions} from "../../modules/forms/forms.actions";
import FormsTable from "./forms/FormsTable";
import {Article, Clear, Search} from "@mui/icons-material";
import PageTitle from "./layout/PageTitle";

function FormsPage({dispatch, ...props}) {
    const [search, setSearch] = useState("");

    useEffect(() => {
        if (!props.forms && !props.loading && !props.error) {
            dispatch(formsActions.fetchForms())
        }
    }, [dispatch, props.forms, props.loading, props.error]);

    const handleDelete = (form) => {
        dispatch(formsActions.deleteForm(form.id));
    }

    const filteredForms = useMemo(() => {
        const forms = props.forms || [];
        const term = search.trim().toLowerCase();
        if (!term) return forms;
        return forms.filter((f) =>
            [f.client?.libelle, f.libelle, f.typologieLavage?.libelle]
                .some((v) => v && String(v).toLowerCase().includes(term))
        );
    }, [props.forms, search]);

    return (
        <>
            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
                <PageTitle title={"Gestion des formulaires"} icon={<Article/>}/>
                <ButtonCreate route={Constants.APP_ROUTE_ADMIN_FORMS_NEW} label="Ajouter un formulaire"/>
            </Stack>

            <TextField
                placeholder="Rechercher (client, libellé, typologie)"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                size="small"
                fullWidth
                sx={{mb: 2}}
                InputProps={{
                    startAdornment: <InputAdornment position="start"><Search fontSize="small"/></InputAdornment>,
                    endAdornment: search
                        ? <InputAdornment position="end" sx={{cursor: "pointer"}} onClick={() => setSearch("")}><Clear fontSize="small"/></InputAdornment>
                        : null,
                }}
            />

            {props.loading
                ? <Loader/>
                : <FormsTable forms={filteredForms} onDelete={handleDelete}/>}
        </>
    )
}

const mapStateToProps = function (state) {
    return {
        forms: state.forms.forms,
        loading: state.forms.loading,
        error: state.forms.error
    }
}

export default connect(mapStateToProps)(FormsPage);
